import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 20px;
	margin-top: 2px;

	button {
		padding: 0 10px;
		width: fit-content;
		border-radius: 5px;
	}
`;

const StyledMenuButtonContent = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	img {
		width: 16px;
		height: 16px;
		user-select: none;
		pointer-events: none;
	}
`;

const StyledIcon = styled.div`
	width: 16px;
	height: 16px;
	mask-size: contain;
	mask-position: center;
	mask-repeat: no-repeat;
	-webkit-mask-size: contain;
	-webkit-mask-position: center;
	-webkit-mask-repeat: no-repeat;
	background-color: #ffffff;
`;

const StyledCount = styled.div`
	width: 16px;
	height: 16px;
	background-color: #ff3d3d;
	border-radius: 16px;
	display: flex;
	align-items: center;
	justify-content: center;

	${Text} {
		font-style: italic;
		font-weight: 700;
		font-size: 12px;
		color: #ffffff;
		opacity: 1;
	}
`;

export { StyledContainer, StyledCount, StyledIcon, StyledMenuButtonContent };
